export const WidthMap = {
  LEFT_MAX_WIDTH: "40px",
  LEFT_MIN_WIDTH: "50px",
  RIGHT_MAX_WIDTH: "40px",
  RIGHT_MIN_WIDTH: "50px",
};
